import React from 'react';
import { ScrollToTopSection } from './warranty/ScrollToTopSection';
import { EyebrowSection } from './warranty/EyebrowSection';
import { HeaderSection } from './warranty/HeaderSection';
import { HeroSection } from './warranty/HeroSection';
import { WarrantySection } from './warranty/WarrantySection';
import { ReturnsSection } from './warranty/ReturnsSection';
import { ClaimProcessSection } from './warranty/ClaimProcessSection';
import { FooterSection } from './warranty/FooterSection';
export function WarrantyPage() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-1065">
      <ScrollToTopSection data-id="element-1066" />
      <EyebrowSection data-id="element-1067" />
      <HeaderSection data-id="element-1068" />
      <main className="flex-grow py-16" data-id="element-1069">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1070">
          <HeroSection data-id="element-1071" />
          <div className="space-y-12" data-id="element-1072">
            <WarrantySection data-id="element-1073" />
            <ReturnsSection data-id="element-1074" />
            <ClaimProcessSection data-id="element-1075" />
          </div>
        </div>
      </main>
      <FooterSection data-id="element-1076" />
    </div>;
}